import { IBaseEventRound } from '../../store/admin/eventRounds/store';
import { IAdminEvent } from '../../store/admin/events/store';
import { IEventItem } from '../../store/player/events/store';

import { addIfUnique } from './addIfUnique';

export const getEventField = (
  event: IAdminEvent | IEventItem
): { address?: string; name: string } => {
  if (!event.rounds || event.rounds.length === 0) {
    return { name: event.courses ? event.courses : 'Course(s) TBD' };
  }

  const coursesIds = (event.rounds as IBaseEventRound[])
    .filter(round => !!round.course)
    .map(round => round.course.id)
    .reduce(addIfUnique, []);

  return coursesIds.length > 1
    ? { name: 'Multiple courses' }
    : event.rounds[0].course
    ? { name: event.rounds[0].course.name, address: event.rounds[0].course.address }
    : { name: 'Course(s) TBD' };
};
